module.exports = __webpack_public_path__ + "img/16268583f5ddc16c0e7ff13b5a865873.png";